import { BaseLocaleLoader } from "./BaseLocaleLoader";
import { enUS as en } from "date-fns/esm/locale";

/**
 * Web implementation of the BaseLocaleLoader component.
 *
 * This implementation loads the messages JSON file from a web server.
 */
export class LocaleLoader extends BaseLocaleLoader {
  switchLocale(locale) {
    const { locales, setCalendar } = this,
      date = locales.date[locale];

    if (date) {
      setCalendar(date);
    } else {
      setCalendar(en);
    }

    fetch(`/locales/${locale}.json`)
      .then(response => {
        if (response.ok) {
          response
            .json()
            .then(messages => this.setState({ locale, messages, date }))
            .catch(error => {
              console.error("A problem occurred loading locale info: ", error);
              // Defining default locale.
              this.switchLocale("en");
            });
        }
      })
      .catch(error =>
        console.error("Error occurred retrieving locale info", error)
      );
  }
}
